import '../css/index.css';

import * as backtotop from './modules/backtotop';
import * as docs from './modules/docs';
import * as navigation from './modules/navigation';

backtotop.init();
docs.init();
navigation.init();
